import { BaseQueryFn } from '@reduxjs/toolkit/query'
import { createApi } from '@reduxjs/toolkit/dist/query/react'

import { FetchFeeDataApiResult } from 'types/entities'

import { fetchFeeData } from 'services/feeData'

type Params = {
  chainId: number
  formatUnits?: 'gwei' | 'wei'
}
const gasPriceQuery =
  (): BaseQueryFn<Params, FetchFeeDataApiResult, Error> =>
  async ({ chainId, formatUnits = 'gwei' }) => {
    try {
      const result = await fetchFeeData({ chainId, formatUnits })

      return {
        data: {
          formatted: result.formatted,
          gasPrice: result?.gasPrice?.toString() || undefined,
          maxFeePerGas: result.maxFeePerGas?.toString() || undefined,
          maxPriorityFeePerGas: result.maxPriorityFeePerGas?.toString() || undefined,
        },
      }
    } catch (error) {
      return { error }
    }
  }
export const feeDataApi = createApi({
  reducerPath: 'gasPrices',
  baseQuery: gasPriceQuery(),
  endpoints: (build) => ({
    getFeeData: build.query<FetchFeeDataApiResult, Params>({
      query: (params: Params) => params,
    }),
  }),
})

export const { useGetFeeDataQuery } = feeDataApi
